import { AxiosResponse } from 'axios';

import { HttpService } from '~system/api/base/http-service';

import { ApiSignUpRequest, ApiSignUpResponse } from '~shared/types';

export const signUp = async (signupData: ApiSignUpRequest) => {
  const data: AxiosResponse<ApiSignUpResponse> = await HttpService.post(
    'auth/quick-signup',
    signupData
  );

  return data;
};

export const quickSignup = async (signupData: ApiSignUpRequest) => {
  const { data }: AxiosResponse<ApiSignUpResponse> = await HttpService.post(
    'auth/quick-signup',
    signupData
  );

  return data;
};
